import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "content"
};
import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
import { getStore, clearStore } from '@/util/store';
import { toLogin } from '@/util/util';
import { getTokenUser, getAccountInfo, getUserInfo } from '@/api/user.js';
import { getReadNotify } from '@/api/home.js';
import { whitePages } from '@/const/white';
import NoticeUpdateDialog from '@/views/Index/Common/NoticeUpdateDialog';
import { reactive, ref } from 'vue';
import useUserStore from '@/stores/modules/user';
import $Bus from '@/util/bus';
import { NOTIFY_UPDATA_EVENT, SHOW_NOTIFY_EVENT } from '@/const/busEvent.js';
import { onBeforeUnmount, onMounted } from 'vue';
import { useLoginChat, useLogoutChat } from '@/hooks/useLoginChat';
export default {
  __name: 'App',
  setup: function setup(__props) {
    var userStore = useUserStore();
    var loginStatus = ref(false);
    var notifyContent = ref(null);
    var visibleNotice = ref(false);
    // 超时

    var access_token = getStore({
      name: 'access_token'
    });
    // 修改accessInfo为函数，确保获取最新数据
    var getAccessInfo = function getAccessInfo() {
      return getStore({
        name: 'accessInfo'
      });
    };
    var userInfo = getStore({
      name: 'userInfo'
    });
    onMounted(function () {
      addBusEvent();
    });
    onBeforeUnmount(function () {
      removeBusEvent();
      useLogoutChat();
    });
    /**
     * 添加事件监听
     */
    var addBusEvent = function addBusEvent() {
      $Bus.on(SHOW_NOTIFY_EVENT, showNotice);
    };
    /**
     * 移除事件监听
     */
    var removeBusEvent = function removeBusEvent() {
      $Bus.off(SHOW_NOTIFY_EVENT, showNotice);
    };
    /**
     * 显示通知
     */
    var showNotice = function showNotice(item) {
      if (item) {
        notifyContent.value = _objectSpread({}, item);
        visibleNotice.value = true;
      }
    };

    /**
     * 获取已读消息
     */
    var getReadNotifyEvent = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, code, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!notifyContent.value) {
                _context.n = 4;
                break;
              }
              _context.p = 1;
              _context.n = 2;
              return getReadNotify(notifyContent.value.id);
            case 2:
              res = _context.v;
              code = res.data.code;
              if (code === 0) {
                $Bus.emit(NOTIFY_UPDATA_EVENT);
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              (_t === null || _t === void 0 ? void 0 : _t.message) && MessagePlugin.warning(_t === null || _t === void 0 ? void 0 : _t.message);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function getReadNotifyEvent() {
        return _ref.apply(this, arguments);
      };
    }();
    var checkWhite = function checkWhite() {
      var whiteList = ['/generate-paper'].concat(whitePages);
      if (!whiteList.includes(location.pathname)) {
        toLogin();
      }
    };
    /**
     * 初始化用户数据
     */
    var initUserData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var result, _result$data, tokenData, code, user_id, accessInfo, res, infoData, mergedData, _res, _infoData, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return getTokenUser(access_token);
            case 1:
              result = _context2.v;
              _result$data = result.data, tokenData = _result$data.data, code = _result$data.code;
              if (!(code === 0 && tokenData)) {
                _context2.n = 6;
                break;
              }
              user_id = tokenData.user_id;
              accessInfo = getAccessInfo();
              if (!(!accessInfo || accessInfo.access_token !== access_token)) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return getAccountInfo(user_id);
            case 2:
              res = _context2.v;
              infoData = res.data.data;
              if (res.data.code === 0 && infoData) {
                // 确保memberType始终是数组
                mergedData = _objectSpread(_objectSpread({}, tokenData), infoData);
                mergedData.memberType = Array.isArray(infoData.memberType) ? infoData.memberType : [tokenData.memberType];
                userStore.getAccountInfo(mergedData);
                // 添加调试代码验证存储是否成功
                console.log('存储后的accessInfo', getStore({
                  name: 'accessInfo'
                }));
              }
            case 3:
              if (userInfo) {
                _context2.n = 5;
                break;
              }
              _context2.n = 4;
              return getUserInfo(user_id);
            case 4:
              _res = _context2.v;
              _infoData = _res.data.data;
              if (_res.data.code === 0 && _infoData) {
                userStore.getUserData(_infoData);
              }
              console.log(1, _infoData);
              useLoginChat(_infoData);
            case 5:
              loginStatus.value = true;
              _context2.n = 7;
              break;
            case 6:
              checkWhite();
            case 7:
              _context2.n = 9;
              break;
            case 8:
              _context2.p = 8;
              _t2 = _context2.v;
              console.log('error', _t2);
            case 9:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 8]]);
      }));
      return function initUserData() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (userInfo && getAccessInfo() && getAccessInfo().access_token === access_token) {
      loginStatus.value = true;
      if (userInfo) useLoginChat(userInfo);
    } else if (access_token) {
      initUserData();
    } else {
      checkWhite();
    }
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return loginStatus.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view), _createVNode(_unref(NoticeUpdateDialog), {
        visible: visibleNotice.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return visibleNotice.value = $event;
        }),
        data: notifyContent.value,
        onChange: getReadNotifyEvent
      }, null, 8, ["visible", "data"])])) : _createCommentVNode("", true);
    };
  }
};